import { generateTestId } from "@client-shared";

const TEST_ID_PREFIX = "OrderShipToCountryCell";

export const setOrderShipToCountryCellTestId = (identifier: string): string => generateTestId(TEST_ID_PREFIX, identifier);

export const ORDER_SHIP_TO_COUNTRY_CELL_TEST_IDS = {
  container: setOrderShipToCountryCellTestId("container"),
} as const;
